export default __webpack_public_path__ + "static/media/medal-1k.9cc638de.svg";